export default __webpack_public_path__ + "static/media/sf.28392204.jpg";